
        import * as module0 from './controllers/clipboard_controller.js';import * as module1 from './controllers/github_star_controller.js';import * as module2 from './controllers/scenario_reveal_controller.js';import * as module3 from './controllers/sponsorship_inquiry_controller.js';import * as module4 from './controllers/support_tracking_controller.js';import * as module5 from './controllers/theme_picker_controller.js'
        const modules = {
            "./controllers/clipboard_controller.js": module0,
            "./controllers/github_star_controller.js": module1,
            "./controllers/scenario_reveal_controller.js": module2,
            "./controllers/sponsorship_inquiry_controller.js": module3,
            "./controllers/support_tracking_controller.js": module4,
            "./controllers/theme_picker_controller.js": module5,
        };
        export default modules;
      